export default __webpack_public_path__ + "static/magento-logo-91b8cbf2a263a1ebf8269a6037915e43.png";